module.exports = __webpack_public_path__ + "img/setup.efbc8f61.svg";